/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_List_LabelInputs */



/**
* | output |
* | --- |
* | "Shortcut" |
*
* @param {Shortcut_Keys_List_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_list_label = /** @type {((inputs?: Shortcut_Keys_List_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_List_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Raccourci")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abkürzung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scorciatoia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Быстрый доступ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("捷径")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートカット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉर्टकट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atalho")
	return /** @type {LocalizedString} */ ("Shortcut")
});